import React from 'react'
import axios from '@/utils/myaxios'
import Cookie from 'js-cookie'
import moment from 'moment'
import { Link } from 'react-router-dom'
import JSONPretty from 'react-json-pretty'
import 'react-json-pretty/themes/1337.css' // 可选主题
import { tableSummaries, isMobileDevice } from '@/utils/utils'
import {
    Button,
    Table,
    message,
    Input,
    Select,
    Tooltip,
    Tag,
    Card,
    Modal,
    Form,
    Switch,
    Row,
    InputNumber,
    Spin,
    Statistic,
    Dropdown,
    Menu,
    Icon,
    Radio,
} from 'antd'

export default class ProxyList extends React.Component {
    state = {
        type: undefined, // 弹窗类型
        title: undefined, // 弹窗标题
        show: false, // 是否显示弹窗
        showDetail: false, // 是否显示详情弹窗
        loading: false, // 是否加载中
        detailLoading: false, // 详情是否加载中
        queryParams: {
            // 查询参数
            page: 1,
            limit: 20,
            total: 0,
            search_value: undefined,
        },
        formData: {
            // 表单数据
            vendor_id: undefined,
            club_name: undefined,
            kpoker_account: undefined,
            currency_code: undefined,
            wallet_type: 1,
            prop_cost_point_rate: undefined,
            avail_fee_rate: undefined,
            avail_ins_rate: undefined,
            avail_cowboy_rate: undefined,
            ins_mod: undefined,
            cowboy_mod: undefined,
            win: undefined,
            lose: undefined,
            white_list: undefined,
        },
        data: [], // 表格数据
        dataInfo: {}, // 数据信息
        proxyData: {}, // 代理资料
        accessConfig: [], // 接入配置资料
        gameCurrencyTypeList: [], // 游戏币类型列表
        selectedDataInfo: {}, // 选中数据
        walletTypeList: [
            // 钱包类型
            { label: this.props.language['transferWallet'], value: 1 },
            { label: this.props.language['singleWallet'], value: 2 },
        ],
    }

    componentDidMount () {
        this.fetchData()
        this.fetchGameCurrencyTypeList()
    }

    /**
     * 获取数据
     */
    fetchData = () => {
        this.setState({ loading: true })
        axios
            .get('/v1/api/kpoker_union/vendor_list', {
                params: {
                    ...this.state.queryParams,
                    search_type: this.state.queryParams.search_value
                        ? 'vendor_id'
                        : undefined,
                    total: undefined,
                },
            })
            .then((res) => {
                this.setState({
                    loading: false,
                    queryParams: {
                        ...this.state.queryParams,
                        total: res.count || 0,
                    },
                    data: res.data || [],
                    dataInfo: res || {},
                })
            })
    }

    /**
     * 获取接入配置资料数据
     */
    fetchAccessConfig = () => {
        this.setState({ detailLoading: true })
        axios
            .get('/v1/api/kpoker_union/vendor_list', {
                params: {
                    page: 1,
                    limit: 100000000,
                },
            })
            .then((res) => {
                let accessConfig = []
                res.data = res.data || []
                res.data.forEach((item) => {
                    if (
                        item.vendor_system_conf &&
                        item.vendor_system_conf.client_id
                    ) {
                        accessConfig.push({
                            agentID: item.vendor_system_conf.vendor_id,
                            systemCode: item.vendor_system_conf.system_code,
                            DesKey: item.vendor_system_conf.des_key,
                            DesIv: item.vendor_system_conf.des_iv,
                            ClientId: item.vendor_system_conf.client_id,
                            ClientSecret: item.vendor_system_conf.client_secret,
                        })
                    }
                })
                this.setState({
                    detailLoading: false,
                    accessConfig: accessConfig,
                })
            })
    }

    /**
     * 获取游戏币类型列表
     */
    fetchGameCurrencyTypeList = () => {
        axios.get('/v1/api/coin/current_effect_rate').then((res) => {
            this.setState({
                gameCurrencyTypeList: res.data || [],
            })
        })
    }

    /**
     * 设置是否能创建牌局
     */
    handleSetAllowCreate = (club_id, value) => {
        axios
            .patch('/v1/api/union_club_allow_create', {
                id: club_id,
                allow: value,
            })
            .then((res) => {
                if (res.code === 1) {
                    message.success(this.props.language['setSuccessMessage'])
                    this.fetchData()
                }
            })
    }

    /**
     * 提交表单
     */
    handleSubmit = () => {
        this.formRef.props.form.validateFields((err, values) => {
            if (!err) {
                if (this.state.type === 'createClub') {
                    // 创建代理俱乐部
                    axios
                        .post(`/v1/api/kpoker_union/add_vendor`, {
                            vendor_id: values.vendor_id,
                            club_name: values.club_name,
                            kpoker_account: values.kpoker_account,
                            currency_code: values.currency_code,
                            wallet_type: values.wallet_type,
                            prop_cost_point_rate: Number(
                                values.prop_cost_point_rate
                            ),
                            avail_fee_rate: Number(values.avail_fee_rate),
                            avail_ins_rate: Number(values.avail_ins_rate),
                            avail_cowboy_rate: Number(values.avail_cowboy_rate),
                            ins_mod: Number(values.ins_mod || 1),
                            cowboy_mod: Number(values.cowboy_mod || 1),
                        })
                        .then((res) => {
                            if (res.code === 1) {
                                message.success(
                                    this.props.language['createSuccessMessage']
                                )
                                this.handleClose()
                                this.fetchData()
                                Modal.success({
                                    title: this.props.language[
                                        'pleaseSaveAccountPassword'
                                    ],
                                    content: (
                                        <div>
                                            <p>
                                                {this.props.language['account']}
                                                ：<b>{res.data.account}</b>
                                            </p>
                                            <p>
                                                {
                                                    this.props.language[
                                                    'password'
                                                    ]
                                                }
                                                ：<b>{res.data.password}</b>
                                            </p>
                                        </div>
                                    ),
                                    okText: this.props.language['copyAndSave'],
                                    onOk: () => {
                                        this.handleCopy(
                                            `${this.props.language['account']}：${res.data.account}\n${this.props.language['password']}：${res.data.password}`,
                                            this.props.language[
                                            'clubAccountPassword'
                                            ]
                                        )
                                    },
                                })
                            }
                        })
                } else if (this.state.type === 'editProportion') {
                    // 编辑分成
                    axios
                        .patch(`/v1/api/kpoker_union/edit_vendor`, {
                            club_id: Number(this.state.formData.club_id),
                            prop_cost_point_rate: Number(
                                values.prop_cost_point_rate
                            ),
                            avail_fee_rate: Number(values.avail_fee_rate),
                            avail_ins_rate: Number(values.avail_ins_rate),
                            avail_cowboy_rate: Number(values.avail_cowboy_rate),
                            ins_mod: Number(values.ins_mod || 1),
                            cowboy_mod: Number(values.cowboy_mod || 1),
                        })
                        .then((res) => {
                            if (res.code === 1) {
                                message.success(
                                    this.props.language['editSuccessMessage']
                                )
                                this.handleClose()
                                this.fetchData()
                            }
                        })
                } else if (this.state.type === 'editWhiteIpList') {
                    // 编辑ip白名单
                    axios
                        .post(`/v1/api/kpoker_union/set_ip_white_list`, {
                            white_list: values.white_list,
                        })
                        .then((res) => {
                            if (res.code === 1) {
                                message.success(
                                    this.props.language['editSuccessMessage']
                                )
                                this.handleClose()
                                this.fetchData()
                            }
                        })
                } else if (
                    this.state.type === 'sendIntegral' ||
                    this.state.type === 'recycleIntegral'
                ) {
                    // 发放、回收积分
                    axios
                        .patch('/v1/api/trans_point', {
                            amount:
                                this.state.type === 'sendIntegral'
                                    ? Number(values.amount)
                                    : -Number(values.amount),
                            cid: Number(this.state.selectedDataInfo.club_id),
                        })
                        .then((res) => {
                            if (res.code === 1) {
                                message.success(
                                    this.props.language[
                                    'operationSuccessMessage'
                                    ]
                                )
                                this.handleClose()
                                this.fetchData()
                            }
                        })
                } else if (this.state.type === 'contribution') {
                    // 更新服务费贡献比例设置
                    axios
                        .patch('/v1/api/union_modify_club_rebate', {
                            win: Number(values.win),
                            lose: Number(values.lose),
                        })
                        .then((res) => {
                            if (res.code === 1) {
                                message.success(
                                    this.props.language[
                                    'operationSuccessMessage'
                                    ]
                                )
                                this.handleClose()
                                this.fetchData()
                            }
                        })
                }
            }
        })
    }

    /**
     * 显示弹窗
     */
    handleShow = (type, item = {}) => {
        let title
        switch (type) {
            case 'createClub':
                title = this.props.language['createProxy']
                break
            case 'proxyData':
                title = this.props.language['proxyInformation']
                break
            case 'accessConfig':
                title = this.props.language['accessConfig']
                break
            case 'sendIntegral':
                title = this.props.language['sendIntergral']
                break
            case 'recycleIntegral':
                title = this.props.language['recycleIntergral']
                break
            case 'editProportion':
                title = this.props.language['editProportion']
                break
            case 'editWhiteIpList':
                title = this.props.language['editWhiteList']
                break
            case 'contribution':
                title =
                    this.props.language['unionServiceContributionProportion']
                break
        }
        if (type === 'proxyData') {
            this.setState(
                {
                    showDetail: true,
                    type,
                    title,
                    proxyData: item.vendor_system_conf || {},
                },
                () => { }
            )
        } else if (type === 'accessConfig') {
            this.setState(
                {
                    showDetail: true,
                    type,
                    title,
                    accessConfig: [],
                },
                () => {
                    this.fetchAccessConfig()
                }
            )
        } else if (type === 'contribution') {
            this.setState({
                show: true,
                type,
                title,
                formData: {
                    win: this.state.dataInfo.positive_profit_prop,
                    lose: this.state.dataInfo.negative_profit_prop,
                },
            })
        } else if (type === 'editProportion') {
            this.setState({
                show: true,
                type,
                title,
                formData: {
                    club_id: item.club_id,
                    prop_cost_point_rate: item.club_prop_cost_point_rate,
                    avail_fee_rate: item.club_avail_fee_rate,
                    avail_ins_rate: item.club_avail_ins_rate,
                    avail_cowboy_rate: item.club_avail_cowboy_rate,
                    ins_mod: item.club_ins_mod || undefined,
                    cowboy_mod: item.club_cowboy_mod || undefined,
                },
            })
        } else if (type === 'editWhiteIpList') {
            this.setState({
                show: true,
                type,
                title,
                formData: {
                    white_list: this.state.dataInfo.white_ips || undefined,
                },
            })
        } else {
            this.setState({
                show: true,
                type,
                title,
                selectedDataInfo: { ...item },
            })
        }
    }

    /**
     * 关闭弹窗
     */
    handleClose = () => {
        this.formRef.props.form.resetFields()
        this.setState({ show: false })
    }

    /**
     * 改变分页
     */
    hanldeChangePage = (pagination) => {
        this.setState(
            {
                queryParams: {
                    ...this.state.queryParams,
                    page: pagination.current,
                    limit: pagination.pageSize,
                },
            },
            () => this.fetchData()
        )
    }

    /**
     * 复制并保存到本地
     */
    handleCopy = (content, title) => {
        // 复制
        const textarea = document.createElement('textarea')
        textarea.value = content
        document.body.appendChild(textarea)
        textarea.select()
        document.execCommand('copy')
        document.body.removeChild(textarea)
        message.success(this.props.language['saveSuccessMessage'])

        // 保存
        const blob = new Blob([content], { type: 'text/plain;charset=utf-8' })
        const url = URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = url
        link.download = `${title}.txt`
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        URL.revokeObjectURL(url)
    }

    /**
     * 设置查询数据
     */
    handleSetQueryParamsData = (key, value) => {
        this.setState({
            queryParams: { ...this.state.queryParams, page: 1, [key]: value },
        })
    }

    /**
     * 重置
     */
    handleReset = () => {
        this.setState(
            {
                queryParams: {
                    page: 1,
                    limit: 20,
                    total: 0,
                    search_value: undefined,
                },
            },
            () => {
                this.fetchData()
            }
        )
    }

    render () {
        return (
            <div className="main-container">
                {/* 表头 */}
                <div className="container-header">
                    <Input
                        allowClear
                        placeholder={this.props.language['proxyIdPlaceholder']}
                        value={this.state.queryParams.search_value}
                        onChange={(e) =>
                            this.handleSetQueryParamsData(
                                'search_value',
                                e.target.value
                            )
                        }
                    />
                    <Button
                        type="primary"
                        icon="search"
                        loading={this.state.loading}
                        onClick={this.fetchData}
                    >
                        {this.props.language['query']}
                    </Button>
                    <Button
                        type="default"
                        icon="reload"
                        onClick={this.handleReset}
                    >
                        {this.props.language['reset']}
                    </Button>
                    <Button
                        type="primary"
                        ghost
                        onClick={() => this.handleShow('createClub')}
                    >
                        {this.props.language['createProxy']}
                    </Button>
                    <Button
                        type="primary"
                        ghost
                        onClick={() => this.handleShow('accessConfig')}
                    >
                        {this.props.language['accessConfig']}
                    </Button>
                    <Button
                        type="primary"
                        ghost
                        onClick={() => this.handleShow('editWhiteIpList')}
                    >
                        {this.props.language['ipWhiteList']}
                    </Button>
                    <Button
                        type="link"
                        onClick={() => window.open('https://kpoker.gitbook.io')}
                    >
                        {this.props.language['onlineAccessDocument']}
                    </Button>
                </div>

                {/* 概况 */}
                <Row type="flex" className="m10 mb0">
                    {/* 柜台积分 */}
                    <div className="number-box-list">
                        <p>{this.props.language['counterPoint']}</p>
                        <div className="value-list">
                            <div className="value-item">
                                <Statistic
                                    value={Number(
                                        this.state.dataInfo.point || 0
                                    )}
                                />
                            </div>
                        </div>
                    </div>

                    {/* 柜台钻石 */}
                    <div className="number-box-list">
                        <p>{this.props.language['counterDiamond']}</p>
                        <div className="value-list">
                            <div className="value-item">
                                <Statistic
                                    value={Number(
                                        this.state.dataInfo.diamond || 0
                                    )}
                                />
                            </div>
                        </div>
                    </div>

                    {/* 可用占比 */}
                    <div className="number-box-list">
                        <p>{this.props.language['availableProportion']}</p>
                        <div className="value-list">
                            <div className="value-item">
                                <Statistic
                                    value={Number(
                                        this.state.dataInfo.avail_fee_rate || 0
                                    )}
                                    suffix="%"
                                />
                                <p className="label">
                                    {this.props.language['serviceFee']}
                                </p>
                            </div>
                            <div className="value-item">
                                <Statistic
                                    value={Number(
                                        this.state.dataInfo.avail_ins_rate || 0
                                    )}
                                    suffix="%"
                                />
                                <p className="label">
                                    {this.props.language['insurance']}
                                </p>
                            </div>
                            <div className="value-item">
                                <Statistic
                                    value={Number(
                                        this.state.dataInfo.avail_cowboy_rate ||
                                        0
                                    )}
                                    suffix="%"
                                />
                                <p className="label">
                                    {this.props.language['cowboy']}
                                </p>
                            </div>
                        </div>
                    </div>

                    {/* 上级超盟服务费贡献比例 */}
                    <div className="number-box-list">
                        <p>
                            {
                                this.props.language[
                                'superUnionServiceContributionProportion'
                                ]
                            }
                        </p>
                        <div className="value-list">
                            <div className="value-item">
                                <Statistic
                                    value={Number(
                                        this.state.dataInfo
                                            .super_positive_profit_prop || 0
                                    )}
                                    suffix="%"
                                />
                                <p className="label">
                                    {this.props.language['winner']}
                                </p>
                            </div>
                            <div className="value-item">
                                <Statistic
                                    value={Number(
                                        this.state.dataInfo
                                            .super_negative_profit_prop || 0
                                    )}
                                    suffix="%"
                                />
                                <p className="label">
                                    {this.props.language['underdog']}
                                </p>
                            </div>
                        </div>
                    </div>

                    {/* 本联盟服务费贡献比例 */}
                    {/* <div className="number-box-list">
                        <div>
                            <p>{this.props.language["unionServiceContributionProportion"]}</p>
                            <Button className="btn" shape="circle" icon="edit" onClick={() => this.handleShow('contribution')}></Button>
                        </div>
                        <div className="value-list">
                            <div className="value-item">
                                <Statistic
                                    value={Number(this.state.dataInfo.positive_profit_prop || 0)}
                                    suffix="%"
                                    valueStyle={{ color: '#ffffffff' }}
                                />
                                <p className="label">{this.props.language["winner"]}</p>
                            </div>
                            <div className="value-item">
                                <Statistic
                                    value={Number(this.state.dataInfo.negative_profit_prop || 0)}
                                    suffix="%"
                                    valueStyle={{ color: '#ffffffff' }}
                                />
                                <p className="label">{this.props.language["underdog"]}</p>
                            </div>
                        </div>
                    </div> */}
                </Row>

                {/* 内容 */}
                <div className="container-content">
                    <Table
                        dataSource={this.state.data}
                        pagination={{
                            showTotal: (total) =>
                                `${this.props.language['total']} ${total} ${this.props.language['item']}`,
                            showQuickJumper: true,
                            showSizeChanger: true,
                            size: isMobileDevice() ? 'small' : '',
                            pageSizeOptions: ['10', '20', '30', '40'],
                            current: this.state.queryParams.page,
                            pageSize: this.state.queryParams.limit,
                            total: this.state.queryParams.total,
                        }}
                        loading={this.state.loading}
                        onChange={this.hanldeChangePage}
                        scroll={{ x: true }}
                        rowKey={(record, index) => index}
                    >
                        <Table.Column
                            align="center"
                            title={this.props.language["proxyId"]}
                            dataIndex=""
                            render={(item) => (
                                <Link to={`/proxy_detail/${item.vendor_id}`}>
                                    {item.vendor_id || ''}
                                </Link>
                            )}
                        />
                        {/* <Table.Column align="center" title={this.props.language["clubId"]} dataIndex="club_id" />
                        <Table.Column
                            align="center"
                            title={this.props.language["clubName"]}
                            dataIndex="club_name"
                        /> */}
                        <Table.Column
                            align="center"
                            title={this.props.language['proxyAccount']}
                            dataIndex="kpoker_account"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language['proxyPlatformTokenType']}
                            dataIndex="currency_name"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language['walletType']}
                            dataIndex=""
                            render={(item) =>
                                this.state.walletTypeList.find(
                                    (item2) => item2.value === item.vendor_system_conf.wallet_type
                                ) ?
                                    this.state.walletTypeList.find(
                                        (item2) => item2.value === item.vendor_system_conf.wallet_type
                                    ).label
                                    : ''
                            }
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language['palyerNumber']}
                            dataIndex="club_member_cnt"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language['counterPoint']}
                            dataIndex="point"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language['propCusomeProportion']}
                            dataIndex=""
                            render={(item) =>
                                `${item.club_prop_cost_point_rate}%`
                            }
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language['serviceProportion']}
                            dataIndex=""
                            render={(item) => `${item.club_avail_fee_rate}%`}
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language['insuranceProportion']}
                            dataIndex=""
                            render={(item) => `${item.club_avail_ins_rate}%`}
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language['cowboyProportion']}
                            dataIndex=""
                            render={(item) => `${item.club_avail_cowboy_rate}%`}
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language['insuranceDivide']}
                            dataIndex=""
                            render={(item) =>
                                item.club_ins_mod === 1
                                    ? this.props.language['risk']
                                    : 'EV'
                            }
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language['cowboyDivide']}
                            dataIndex=""
                            render={(item) =>
                                item.club_cowboy_mod === 1
                                    ? this.props.language['risk']
                                    : 'EV'
                            }
                        />
                        {/* <Table.Column
                            align="center"
                            title={this.props.language["allowCreateTable"]}
                             dataIndex=""
                            fixed={isMobileDevice() ? false : "right"}
                            width={120}
                            dataIndex=""
                            render={(item) => {
                                return (
                                    <Switch
                                        checked={item.allow_create === 1}
                                        onChange={(value) =>
                                            this.handleSetAllowCreate(item.club_id, value)
                                        }
                                    />
                                );
                            }}
                        /> */}
                        <Table.Column
                            align="center"
                            title={this.props.language['operation']}
                            dataIndex=""
                            fixed={isMobileDevice() ? false : 'right'}
                            width={220}
                            render={(item) => (
                                <>
                                    <Button
                                        type="default"
                                        onClick={() =>
                                            this.handleShow('proxyData', item)
                                        }
                                    >
                                        {
                                            this.props.language[
                                            'proxyInformation'
                                            ]
                                        }
                                    </Button>
                                    <Dropdown
                                        trigger={['click']}
                                        className="ml10"
                                        overlay={
                                            <Menu
                                                onClick={({ key }) =>
                                                    this.handleShow(key, item)
                                                }
                                            >
                                                <Menu.Item key="sendIntegral">
                                                    {
                                                        this.props.language[
                                                        'sendIntergral'
                                                        ]
                                                    }
                                                </Menu.Item>
                                                <Menu.Item key="recycleIntegral">
                                                    {
                                                        this.props.language[
                                                        'recycleIntergral'
                                                        ]
                                                    }
                                                </Menu.Item>
                                                <Menu.Item key="editProportion">
                                                    {
                                                        this.props.language[
                                                        'editProportion'
                                                        ]
                                                    }
                                                </Menu.Item>
                                            </Menu>
                                        }
                                    >
                                        <Button type="primary" ghost>
                                            {this.props.language['operation']}
                                            <Icon type="down" />
                                        </Button>
                                    </Dropdown>
                                </>
                            )}
                        />
                    </Table>
                </div>

                {/* 表单弹窗 */}
                <FormModal
                    {...this.props}
                    visible={this.state.show}
                    type={this.state.type}
                    title={this.state.title}
                    formData={this.state.formData}
                    gameCurrencyTypeList={this.state.gameCurrencyTypeList}
                    walletTypeList={this.state.walletTypeList}
                    onOk={this.handleSubmit}
                    onCancel={this.handleClose}
                    wrappedComponentRef={(formRef) => (this.formRef = formRef)}
                />

                {/* 代理资料、接入配置弹窗 */}
                <DetailModal
                    {...this.props}
                    visible={this.state.showDetail}
                    title={this.state.title}
                    type={this.state.type}
                    detailLoading={this.state.detailLoading}
                    proxyData={this.state.proxyData}
                    accessConfig={this.state.accessConfig}
                    handleCopy={this.handleCopy}
                    onCancel={() => this.setState({ showDetail: false })}
                />
            </div>
        )
    }
}

/**
 * 表单弹窗
 */
const FormModal = Form.create({ name: 'form_model' })(
    class FormBox extends React.Component {
        render () {
            const { getFieldDecorator } = this.props.form
            return (
                <Modal
                    maskClosable={false}
                    width={600}
                    title={this.props.title}
                    visible={this.props.visible}
                    onOk={this.props.onOk}
                    onCancel={this.props.onCancel}
                    centered={isMobileDevice()}
                    bodyStyle={{
                        maxHeight: '70vh',
                        overflowY: 'auto',
                    }}
                >
                    <div className="container-content">
                        <Form>
                            {/* 创建代理 */}
                            {this.props.type === 'createClub' && (
                                <>
                                    <Form.Item
                                        label={`${this.props.language['proxyId']} ${this.props.language['proxyIdSuffix']}`}
                                    >
                                        {getFieldDecorator('vendor_id', {
                                            rules: [
                                                {
                                                    required: true,
                                                    message:
                                                        this.props.language[
                                                        'proxyIdVerify'
                                                        ],
                                                },
                                                {
                                                    pattern: /^.{3,64}$/,
                                                    message:
                                                        this.props.language[
                                                        'proxyIdVerify1'
                                                        ],
                                                    trigger: 'blur',
                                                },
                                            ],
                                            initialValue:
                                                this.props.formData.vendor_id,
                                        })(
                                            <Input
                                                maxLength={64}
                                                allowClear
                                                placeholder={
                                                    this.props.language[
                                                    'proxyIdPlaceholder'
                                                    ]
                                                }
                                            />
                                        )}
                                    </Form.Item>
                                    <Form.Item
                                        label={`${this.props.language['proxy']} ${this.props.language['proxySuffix']}`}
                                    >
                                        {getFieldDecorator('club_name', {
                                            rules: [
                                                {
                                                    required: true,
                                                    message:
                                                        this.props.language[
                                                        'proxyVerify'
                                                        ],
                                                },
                                                {
                                                    pattern: /^.{3,20}$/,
                                                    message:
                                                        this.props.language[
                                                        'proxyVerify1'
                                                        ],
                                                    trigger: 'blur',
                                                },
                                            ],
                                            initialValue:
                                                this.props.formData.club_name,
                                        })(
                                            <Input
                                                maxLength={20}
                                                allowClear
                                                placeholder={
                                                    this.props.language[
                                                    'proxyPlaceholder'
                                                    ]
                                                }
                                            />
                                        )}
                                    </Form.Item>
                                    <Form.Item
                                        label={
                                            this.props.language['proxyAccount']
                                        }
                                    >
                                        {getFieldDecorator('kpoker_account', {
                                            rules: [
                                                {
                                                    required: true,
                                                    message:
                                                        this.props.language[
                                                        'proxyAccountVerify'
                                                        ],
                                                },
                                                {
                                                    pattern:
                                                        /^[A-Za-z0-9]{4,16}$/,
                                                    message:
                                                        this.props.language[
                                                        'proxyAccountVerify1'
                                                        ],
                                                    trigger: 'blur',
                                                },
                                            ],
                                            initialValue:
                                                this.props.formData
                                                    .kpoker_account,
                                        })(
                                            <Input
                                                maxLength={16}
                                                allowClear
                                                placeholder={
                                                    this.props.language[
                                                    'proxyAccountPlaceholder'
                                                    ]
                                                }
                                            />
                                        )}
                                    </Form.Item>
                                    <Form.Item
                                        label={
                                            this.props.language[
                                            'proxyPlatformTokenType'
                                            ]
                                        }
                                    >
                                        {getFieldDecorator('currency_code', {
                                            rules: [
                                                {
                                                    required: true,
                                                    message:
                                                        this.props.language[
                                                        'proxyPlatformTokenTypeVerify'
                                                        ],
                                                },
                                            ],
                                            initialValue:
                                                this.props.formData
                                                    .currency_code,
                                        })(
                                            <Select
                                                allowClear
                                                showSearch
                                                optionFilterProp="children"
                                                placeholder={
                                                    this.props.language[
                                                    'proxyPlatformTokenTypePlaceholder'
                                                    ]
                                                }
                                            >
                                                {this.props.gameCurrencyTypeList.map(
                                                    (item, index) => (
                                                        <Select.Option
                                                            value={
                                                                item.currency_code
                                                            }
                                                            key={index}
                                                        >
                                                            {item.currency_name}
                                                            {Cookie.get("isAce1") !== 'true' &&
                                                                <span >（1:{item.currency_rate}:{item.usdt_rate}）</span>
                                                            }
                                                            {Cookie.get("isAce1") === 'true' &&
                                                                <span >（{item.currency_rate}:1）</span>
                                                            }
                                                        </Select.Option>
                                                    )
                                                )}
                                            </Select>
                                        )}
                                    </Form.Item>
                                    <Form.Item
                                        label={this.props.language['walletType']}
                                    >
                                        {getFieldDecorator('wallet_type', {
                                            rules: [
                                                {
                                                    required: true,
                                                    message:
                                                        this.props.language[
                                                        'walletTypeVerify'
                                                        ],
                                                },
                                            ],
                                            initialValue: this.props.formData.wallet_type,
                                        })(
                                            <Radio.Group
                                                disabled={
                                                    this.props.type === 'edit'
                                                }
                                            >
                                                {this.props.walletTypeList.map(
                                                    (item, index) => (
                                                        <Radio
                                                            key={index}
                                                            value={item.value}
                                                        >
                                                            {item.label}
                                                        </Radio>
                                                    )
                                                )}
                                            </Radio.Group>
                                        )}
                                    </Form.Item>
                                    <Form.Item
                                        label={
                                            this.props.language[
                                            'propCusomeProportion'
                                            ]
                                        }
                                    >
                                        {getFieldDecorator(
                                            'prop_cost_point_rate',
                                            {
                                                rules: [
                                                    {
                                                        required: true,
                                                        message:
                                                            this.props.language[
                                                            'propCusomeProportionVerify'
                                                            ],
                                                    },
                                                ],
                                                initialValue:
                                                    this.props.formData
                                                        .prop_cost_point_rate,
                                            }
                                        )(
                                            <InputNumber
                                                min={0}
                                                max={100}
                                                precision={0}
                                                placeholder={
                                                    this.props.language[
                                                    'propCusomeProportionPlaceholder'
                                                    ]
                                                }
                                                formatter={(value) =>
                                                    `${value}%`
                                                }
                                            />
                                        )}
                                    </Form.Item>
                                    <Form.Item
                                        label={
                                            this.props.language[
                                            'serviceProportion'
                                            ]
                                        }
                                    >
                                        {getFieldDecorator('avail_fee_rate', {
                                            rules: [
                                                {
                                                    required: true,
                                                    message:
                                                        this.props.language[
                                                        'serviceProportionVerify'
                                                        ],
                                                },
                                            ],
                                            initialValue:
                                                this.props.formData
                                                    .avail_fee_rate,
                                        })(
                                            <InputNumber
                                                min={0}
                                                max={100}
                                                precision={0}
                                                placeholder={
                                                    this.props.language[
                                                    'serviceProportionPlaceholder'
                                                    ]
                                                }
                                                formatter={(value) =>
                                                    `${value}%`
                                                }
                                            />
                                        )}
                                    </Form.Item>
                                    <Form.Item
                                        label={
                                            this.props.language[
                                            'insuranceProportion'
                                            ]
                                        }
                                    >
                                        {getFieldDecorator('avail_ins_rate', {
                                            rules: [
                                                {
                                                    required: true,
                                                    message:
                                                        this.props.language[
                                                        'insuranceProportionVerify'
                                                        ],
                                                },
                                            ],
                                            initialValue:
                                                this.props.formData
                                                    .avail_ins_rate,
                                        })(
                                            <InputNumber
                                                min={0}
                                                max={100}
                                                precision={0}
                                                placeholder={
                                                    this.props.language[
                                                    'insuranceProportionPlaceholder'
                                                    ]
                                                }
                                                formatter={(value) =>
                                                    `${value}%`
                                                }
                                            />
                                        )}
                                    </Form.Item>
                                    <Form.Item
                                        label={
                                            this.props.language[
                                            'cowboyProportion'
                                            ]
                                        }
                                    >
                                        {getFieldDecorator(
                                            'avail_cowboy_rate',
                                            {
                                                rules: [
                                                    {
                                                        required: true,
                                                        message:
                                                            this.props.language[
                                                            'cowboyProportionVerify'
                                                            ],
                                                    },
                                                ],
                                                initialValue:
                                                    this.props.formData
                                                        .avail_cowboy_rate,
                                            }
                                        )(
                                            <InputNumber
                                                min={0}
                                                max={100}
                                                precision={0}
                                                placeholder={
                                                    this.props.language[
                                                    'cowboyProportionPlaceholder'
                                                    ]
                                                }
                                                formatter={(value) =>
                                                    `${value}%`
                                                }
                                            />
                                        )}
                                    </Form.Item>
                                    {/* <Form.Item label="保险分成">
                                        {getFieldDecorator("ins_mod", {
                                            rules: [{ required: true, message: this.props.language["insuranceDivideVerify"] }],
                                            initialValue: this.props.formData.ins_mod,
                                        })(
                                            <Radio.Group>
                                                <Radio value={1}>{this.props.language["risk"]}</Radio>
                                                <Radio value={2}>EV</Radio>
                                            </Radio.Group>
                                        )}
                                    </Form.Item>
                                    <Form.Item label={this.props.language["cowboyDivide"]}>
                                        {getFieldDecorator("cowboy_mod", {
                                            rules: [{ required: true, message: this.props.language["cowboyDivideVerify"] }],
                                            initialValue: this.props.formData.cowboy_mod,
                                        })(
                                            <Radio.Group>
                                                <Radio value={1}>{this.props.language["risk"]}</Radio>
                                                <Radio value={2}>EV</Radio>
                                            </Radio.Group>
                                        )}
                                    </Form.Item> */}
                                </>
                            )}

                            {/* 编辑分成 */}
                            {this.props.type === 'editProportion' && (
                                <>
                                    <Form.Item
                                        label={
                                            this.props.language[
                                            'propCusomeProportion'
                                            ]
                                        }
                                    >
                                        {getFieldDecorator(
                                            'prop_cost_point_rate',
                                            {
                                                rules: [
                                                    {
                                                        required: true,
                                                        message:
                                                            this.props.language[
                                                            'propCusomeProportionVerify'
                                                            ],
                                                    },
                                                ],
                                                initialValue:
                                                    this.props.formData
                                                        .prop_cost_point_rate,
                                            }
                                        )(
                                            <InputNumber
                                                min={0}
                                                max={100}
                                                precision={0}
                                                placeholder={
                                                    this.props.language[
                                                    'propCusomeProportionPlaceholder'
                                                    ]
                                                }
                                                formatter={(value) =>
                                                    `${value}%`
                                                }
                                            />
                                        )}
                                    </Form.Item>
                                    <Form.Item
                                        label={
                                            this.props.language[
                                            'serviceProportion'
                                            ]
                                        }
                                    >
                                        {getFieldDecorator('avail_fee_rate', {
                                            rules: [
                                                {
                                                    required: true,
                                                    message:
                                                        this.props.language[
                                                        'serviceProportionVerify'
                                                        ],
                                                },
                                            ],
                                            initialValue:
                                                this.props.formData
                                                    .avail_fee_rate,
                                        })(
                                            <InputNumber
                                                min={0}
                                                max={100}
                                                precision={0}
                                                placeholder={
                                                    this.props.language[
                                                    'serviceProportionPlaceholder'
                                                    ]
                                                }
                                                formatter={(value) =>
                                                    `${value}%`
                                                }
                                            />
                                        )}
                                    </Form.Item>
                                    <Form.Item
                                        label={
                                            this.props.language[
                                            'insuranceProportion'
                                            ]
                                        }
                                    >
                                        {getFieldDecorator('avail_ins_rate', {
                                            rules: [
                                                {
                                                    required: true,
                                                    message:
                                                        this.props.language[
                                                        'insuranceProportionVerify'
                                                        ],
                                                },
                                            ],
                                            initialValue:
                                                this.props.formData
                                                    .avail_ins_rate,
                                        })(
                                            <InputNumber
                                                min={0}
                                                max={100}
                                                precision={0}
                                                placeholder={
                                                    this.props.language[
                                                    'insuranceProportionPlaceholder'
                                                    ]
                                                }
                                                formatter={(value) =>
                                                    `${value}%`
                                                }
                                            />
                                        )}
                                    </Form.Item>
                                    <Form.Item
                                        label={
                                            this.props.language[
                                            'cowboyProportion'
                                            ]
                                        }
                                    >
                                        {getFieldDecorator(
                                            'avail_cowboy_rate',
                                            {
                                                rules: [
                                                    {
                                                        required: true,
                                                        message:
                                                            this.props.language[
                                                            'cowboyProportionVerify'
                                                            ],
                                                    },
                                                ],
                                                initialValue:
                                                    this.props.formData
                                                        .avail_cowboy_rate,
                                            }
                                        )(
                                            <InputNumber
                                                min={0}
                                                max={100}
                                                precision={0}
                                                placeholder={
                                                    this.props.language[
                                                    'cowboyProportionPlaceholder'
                                                    ]
                                                }
                                                formatter={(value) =>
                                                    `${value}%`
                                                }
                                            />
                                        )}
                                    </Form.Item>
                                    {/* <Form.Item label="保险分成">
                                        {getFieldDecorator("ins_mod", {
                                            rules: [{ required: true, message: this.props.language["insuranceDivideVerify"] }],
                                            initialValue: this.props.formData.ins_mod,
                                        })(
                                            <Radio.Group>
                                                <Radio value={1}>{this.props.language["risk"]}</Radio>
                                                <Radio value={2}>EV</Radio>
                                            </Radio.Group>
                                        )}
                                    </Form.Item>
                                    <Form.Item label={this.props.language["cowboyDivide"]}>
                                        {getFieldDecorator("cowboy_mod", {
                                            rules: [{ required: true, message: this.props.language["cowboyDivideVerify"] }],
                                            initialValue: this.props.formData.cowboy_mod,
                                        })(
                                            <Radio.Group>
                                                <Radio value={1}>{this.props.language["risk"]}</Radio>
                                                <Radio value={2}>EV</Radio>
                                            </Radio.Group>
                                        )}
                                    </Form.Item> */}
                                </>
                            )}

                            {/* 编辑ip白名单 */}
                            {this.props.type === 'editWhiteIpList' && (
                                <>
                                    <Form.Item
                                        label={`${this.props.language['ipWhiteList']}${this.props.language['ipWhiteListFix']}`}
                                    >
                                        {getFieldDecorator('white_list', {
                                            rules: [
                                                {
                                                    required: false,
                                                    message:
                                                        this.props.language[
                                                        'ipWhiteListVerify'
                                                        ],
                                                },
                                            ],
                                            initialValue:
                                                this.props.formData.white_list,
                                        })(
                                            <Input.TextArea
                                                rows={5}
                                                maxLength={140}
                                                allowClear
                                                placeholder={
                                                    this.props.language[
                                                    'ipWhiteListPlaceholder'
                                                    ]
                                                }
                                            />
                                        )}
                                    </Form.Item>
                                </>
                            )}

                            {/* 发放回收积分 */}
                            {(this.props.type == 'sendIntegral' ||
                                this.props.type == 'recycleIntegral') && (
                                    <>
                                        <Form.Item
                                            label={this.props.language['amount']}
                                        >
                                            {getFieldDecorator('amount', {
                                                rules: [
                                                    {
                                                        required: true,
                                                        message:
                                                            this.props.language[
                                                            'amountVerify'
                                                            ],
                                                    },
                                                ],
                                                initialValue:
                                                    this.props.formData.amount,
                                            })(
                                                <InputNumber
                                                    min={1}
                                                    max={100000000}
                                                    precision={0}
                                                    placeholder={
                                                        this.props.language[
                                                        'amountPlaceholder'
                                                        ]
                                                    }
                                                />
                                            )}
                                        </Form.Item>
                                    </>
                                )}

                            {/* 本联盟服务费贡献比例 */}
                            {this.props.type === 'contribution' && (
                                <>
                                    <Form.Item
                                        label={
                                            this.props.language[
                                            'winnerProportion'
                                            ]
                                        }
                                    >
                                        {getFieldDecorator('win', {
                                            rules: [
                                                {
                                                    required: true,
                                                    message:
                                                        this.props.language[
                                                        'winnerProportionPlaceholder'
                                                        ],
                                                },
                                            ],
                                            initialValue:
                                                this.props.formData.win,
                                        })(
                                            <InputNumber
                                                min={0}
                                                max={100}
                                                precision={0}
                                                placeholder={
                                                    this.props.language[
                                                    'winnerProportionPlaceholder'
                                                    ]
                                                }
                                                formatter={(value) =>
                                                    `${value}%`
                                                }
                                            />
                                        )}
                                    </Form.Item>
                                    <Form.Item
                                        label={
                                            this.props.language[
                                            'loserProportion'
                                            ]
                                        }
                                    >
                                        {getFieldDecorator('lose', {
                                            rules: [
                                                {
                                                    required: true,
                                                    message:
                                                        this.props.language[
                                                        'loserProportionPlaceholder'
                                                        ],
                                                },
                                            ],
                                            initialValue:
                                                this.props.formData.lose,
                                        })(
                                            <InputNumber
                                                min={0}
                                                max={100}
                                                precision={0}
                                                placeholder={
                                                    this.props.language[
                                                    'loserProportionPlaceholder'
                                                    ]
                                                }
                                                formatter={(value) =>
                                                    `${value}%`
                                                }
                                            />
                                        )}
                                    </Form.Item>
                                </>
                            )}
                        </Form>
                    </div>
                </Modal>
            )
        }
    }
)

/**
 * 代理资料、接入配置弹窗
 */
class DetailModal extends React.Component {
    render () {
        return (
            <Modal
                maskClosable={false}
                width={this.props.type === 'accessConfig' ? 600 : 1200}
                title={
                    this.props.type === 'accessConfig' ? (
                        <>
                            <span>{this.props.title}</span>
                            <span>
                                （{this.props.language['apiAddress']}：
                                {process.env.NODE_ENV === 'development' ? (
                                    <Button
                                        className="fs16"
                                        type="link"
                                        onClick={() =>
                                            window.open(
                                                'https://gameapi.njnunsdf.us/gameApi'
                                            )
                                        }
                                    >
                                        https://gameapi.njnunsdf.us/gameApi
                                    </Button>
                                ) : (
                                    <Button
                                        className="fs16"
                                        type="link"
                                        onClick={() =>
                                            window.open(
                                                'https://gameapi.saduminominaip.online:8001/gameApi'
                                            )
                                        }
                                    >
                                        https://gameapi.saduminominaip.online:8001/gameApi
                                    </Button>
                                )}
                                ）
                            </span>
                        </>
                    ) : (
                        this.props.title
                    )
                }
                visible={this.props.visible}
                onCancel={this.props.onCancel}
                centered={isMobileDevice()}
                bodyStyle={{
                    maxHeight: '70vh',
                    overflowY: 'auto',
                    padding: this.props.type === 'accessConfig' ? 0 : 24,
                }}
                footer={
                    this.props.type === 'accessConfig' ? (
                        <Button
                            type="primary"
                            onClick={() =>
                                this.props.handleCopy(
                                    JSON.stringify(
                                        this.props.accessConfig,
                                        null,
                                        4
                                    ),
                                    this.props.title
                                )
                            }
                        >
                            {this.props.language['copyAndSave']}
                        </Button>
                    ) : null
                }
            >
                <Spin spinning={this.props.detailLoading}>
                    {/* 代理资料 */}
                    {this.props.type === 'proxyData' && (
                        <Table
                            dataSource={
                                this.props.proxyData.vendor_id
                                    ? [this.props.proxyData]
                                    : []
                            }
                            pagination={false}
                            scroll={{ x: true }}
                            rowKey={(record, index) => index}
                        >
                            <Table.Column
                                align="center"
                                title={
                                    this.props.language['proxySystemAddress']
                                }
                                render={(item) =>
                                    process.env.NODE_ENV === 'development' ? (
                                        Cookie.get("isAce1") === 'true' ?
                                            <Button
                                                type="link"
                                                onClick={() =>
                                                    window.open(
                                                        'https://ace1.njnunsdf.us'
                                                    )
                                                }
                                            >
                                                https://ace1.njnunsdf.us
                                            </Button>
                                            :
                                            <Button
                                                type="link"
                                                onClick={() =>
                                                    window.open(
                                                        'https://kpoker.njnunsdf.us'
                                                    )
                                                }
                                            >
                                                https://kpoker.njnunsdf.us
                                            </Button>

                                    ) : (
                                        Cookie.get("isAce1") === 'true' ?
                                            <Button
                                                type="link"
                                                onClick={() =>
                                                    window.open(
                                                        'https://ace1.saduminominaip.online'
                                                    )
                                                }
                                            >
                                                https://ace1.saduminominaip.online
                                            </Button>
                                            :
                                            <Button
                                                type="link"
                                                onClick={() =>
                                                    window.open(
                                                        'https://kpoker.saduminominaip.online'
                                                    )
                                                }
                                            >
                                                https://kpoker.saduminominaip.online
                                            </Button>
                                    )
                                }
                            />
                            <Table.Column
                                align="center"
                                title={this.props.language['proxyAccount']}
                                dataIndex="kpoker_account"
                            />
                            <Table.Column
                                align="center"
                                title={this.props.language['initPassword']}
                                dataIndex="init_pass"
                            />
                            <Table.Column
                                align="center"
                                title={this.props.language['systemCode']}
                                dataIndex="system_code"
                            />
                            <Table.Column
                                align="center"
                                title="DesKey"
                                dataIndex="des_key"
                            />
                            <Table.Column
                                align="center"
                                title="DesIv"
                                dataIndex="des_iv"
                            />
                            <Table.Column
                                align="center"
                                title="ClientId"
                                dataIndex="client_id"
                            />
                            <Table.Column
                                align="center"
                                title="ClientSecret"
                                dataIndex="client_secret"
                            />
                        </Table>
                    )}

                    {/* 接入配置 */}
                    {this.props.type === 'accessConfig' && (
                        <JSONPretty
                            id="json-pretty"
                            data={this.props.accessConfig}
                        ></JSONPretty>
                    )}
                </Spin>
            </Modal>
        )
    }
}
